<template>
  <div class="input-group">
    <select
      @change="() => onStatusChange(newStatus)"
      v-if="invoice.status != 3"
      v-model="newStatus"
      class="form-control"
    >
      <option
        v-for="status in getSortedInvoiceStatuses()"
        v-if="!status.invoiceTypeOnly || (status.invoiceTypeOnly.includes(invoice.type))"
        :value="status.id"
      >{{ status.title }}
      </option
      >
    </select>
    <select v-if="invoice.type === 1" v-model="invoice.sub_status" class="form-control">
      <option value="">Без подсклада</option>
      <!--      <template v-for="(s, store) in getSortedSubStores()">-->
      <!--        <optgroup label="-&#45;&#45;">-->
      <option v-for="s in getSortedSubStores()" :value="s.id">{{ s.title }}</option>
      <!--        </optgroup>-->
      <!--      </template>-->
    </select>
  </div>
</template>

<script>

export default {
  props: ['invoice', 'onStatusChange'],
  mounted() {
    // await this.$store.dispatch('getVersion')
    this.newStatus = this.invoice.status;
  },
  // asyncComputed: {
  //   $invoiceSubStatuses() {
  //     return new Promise(async (resolve, reject) => {
  //       const data = this.$store.getters['invoices/subStatuses'];
  //       console.log(data);
  //       // setTimeout(() => resolve('Changed Value!'), 1000)
  //     })
  //   }
  // },
  computed: {
    $invoiceSubStatuses() {
      return this.$store.getters['invoices/subStatuses'];
    },
    $AllStores() {
      return this.$store.getters['platform/stores'];
    },
  },
  data() {
    return {
      newStatus: 0,
      sortedInvoiceStatuses: [
        {title: 'предварительная ведомость', id: 1},
        {title: 'в дороге', id: 2},
        {title: 'фактическое поступление', id: 0},
        {title: 'модерация', id: 3},
        {title: 'сборка', id: 4},
        // {title: 'резерв', id: 5, invoiceTypeOnly: [1]},
        {title: 'резерв', id: 5},
        {title: 'проверка приемки', id: 6},
      ],
    }
  },
  methods: {
    getSortedInvoiceStatuses() {
      if (+this.invoice.status === 6) {
        return [this.sortedInvoiceStatuses[6], this.sortedInvoiceStatuses[2]];
      }
      return [...this.sortedInvoiceStatuses];
    },
    getSortedSubStores() {
      const subStores = this.$invoiceSubStatuses.reduce((acc, s) => {
        // if (!acc[s.store_id]) acc[s.store_id] = [];
        // acc[s.store_id].push(s)
        if (s.store_id === this.invoice.store_in) {
          acc.push(s)
        }
        return acc;
      }, []);
      return subStores;
    }
  }
}

</script>
